<template>
    <div class="auth-venue-register-container">
        <div class="titles">
            <p class="title-white">Let's set up your</p>
            <p class="title-purple">Booking Profile</p>
        </div>
        <div class="form-wrapper">
            <div class="venue-name-input-wrapper">
                <label for="venue-name">Business Name*</label>
                <input
                    ref="autocomplete"
                    v-model="$v.firstFormValues.venue_name.$model"
                    v-autofocus
                    :class="{
                        'error-input':
                            $v.firstFormValues.venue_name.$dirty &&
                            !$v.firstFormValues.venue_name.required
                    }"
                    @blur="$v.firstFormValues.venue_name.$touch"
                    type="text"
                    placeholder="Eg. The Roadhouse"
                />
            </div>
            <div v-if="!hideSocialLinks" class="social-link-wrapper">
                <auth-link-social role="venue">
                    <template #message>
                        <p>Links & Social Media</p>
                        <p>
                            We'll need at least one social linked to make your profile public.
                        </p>
                    </template>
                </auth-link-social>
            </div>
        </div>
        <button @click="handleFirstFormContinue($v)" class="continue-btn">Continue</button>
        <button @click="handleFirstFormBack" class="back-btn">Back</button>
    </div>
</template>
<script>
    import { useVenueRegister } from '@/composables/auth/useVenueRegister'
    import AuthLinkSocial from '@/components/auth/parts/AuthLinkSocial.vue'
    import { required } from 'vuelidate/lib/validators'
    export default {
        name: 'AuthVenueRegisterFirstStep',
        components: { AuthLinkSocial },
        validations: {
            firstFormValues: {
                venue_name: { required }
            }
        },
        setup() {
            const {
                hideSocialLinks,
                firstFormValues,
                autocomplete,
                handleFirstFormContinue,
                handleFirstFormBack
            } = useVenueRegister()

            return {
                hideSocialLinks,
                firstFormValues,
                autocomplete,
                handleFirstFormContinue,
                handleFirstFormBack
            }
        }
    }
</script>
<style lang="scss" scoped>
    .auth-venue-register-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 40px;

        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        .titles {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            width: 100%;

            p {
                font-family: Instrument Sans;
                font-size: 38px;
                font-style: normal;
                font-weight: 500;
                line-height: 110%;
                letter-spacing: -0.76px;
            }
            .title-white {
                color: #dedede;
            }
            .title-purple {
                color: #ba87ff;
            }
        }

        .form-wrapper {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 24px;
            width: 100%;

            label {
                color: #8b8b8b;
                font-family: Instrument Sans;
                font-size: 12px;
                font-style: normal;
                font-weight: 650;
                line-height: 135%;
                letter-spacing: 0.12px;
            }
            input {
                padding: 12px 16px 16px 16px;
                border-radius: 12px;
                border: 1px solid #8b8b8b;
                width: 100%;
                color: #dedede;
                background: inherit;
                font-family: Instrument Sans;
                font-size: 16px;
                font-style: normal;
                font-weight: 550;
                line-height: 125%;
            }
            input::placeholder {
                overflow: hidden;
                color: #646464;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-family: Instrument Sans;
                font-size: 16px;
                font-style: normal;
                font-weight: 550;
                line-height: 125%;
            }
            .error-input {
                border-color: #ed3c0d !important;
            }
            .venue-name-input-wrapper {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-end;
                gap: 6px;
            }

            .social-link-wrapper {
                width: 100%;

                p {
                    color: #8b8b8b;
                    font-family: Instrument Sans;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 650;
                    line-height: 135%;
                    letter-spacing: 0.12px;
                }
            }
        }
        .continue-btn {
            padding: 11px 30px 12px 30px;
            border-radius: 100px;
            background: #cdeb09;
            color: black;
            font-family: Instrument Sans;
            font-size: 18px;
            font-style: normal;
            font-weight: 550;
            line-height: 120%;
            width: 100%;
        }
        .back-btn {
            color: #8b8b8b;
            text-align: center;
            font-family: Instrument Sans;
            font-size: 16px;
            font-style: normal;
            font-weight: 550;
            line-height: 125%;
            text-decoration-line: underline;
            background: none;
        }
    }
</style>
